import * as React from "react";
import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { addUserPick, removeUserPick } from "../../store/picks/userPick-slice";
import store from "../../store/store";
import ModalMessage from "../Common/ModalMessage/ModalMessage";
import { playAudioEffect } from "../../store/audio-slice";
import { AudioEnum } from "../../enums";

interface Props {
  value: string;
  valueMultiplier: number;
}

const StakeNumberMultiplier: React.FC<Props> = ({ value, valueMultiplier }) => {
  const [active, setActive] = useState(false);
  const pickedStakes = useAppSelector((state) => state.picks.pickedStakes);
  const [infoModalMessage, setInfoModalMessage] = useState("");
  const dispatch = useAppDispatch();

  useEffect(() => {
    const stakeIndex = pickedStakes.findIndex((stake) => stake.value === value);

    const stakeForRestore = pickedStakes[stakeIndex];
    if (
      stakeForRestore?.valueMultipliers.find(
        (multiplier) => multiplier === valueMultiplier
      )
    ) {
      setActive(true);
    } else {
      setActive(false);
    }
  }, [pickedStakes, value, valueMultiplier]);

  const activeButtonHandler = (): void => {
    if (!active) {
      if (
        valueMultiplier + store.getState().picks.currentStakeAmount >
        store.getState().config.maxLocationStake / 100
      ) {
        setInfoModalMessage("message.maxStakeReached");
      } else {
        dispatch(
          addUserPick({
            value,
            valueMultiplier,
          })
        );
        setActive(true);
      }
    } else {
      dispatch(removeUserPick({ value, valueMultiplier }));
      setActive(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className={`number ${active ? "active" : ""}`}
        onClick={() => {
          activeButtonHandler();
          dispatch(
            playAudioEffect(
              active ? AudioEnum.EFFECT_DELETE : AudioEnum.EFFECT_MULTIPLIER
            )
          );
        }}
      >
        <div className="number_box">{valueMultiplier}</div>
      </button>
      {infoModalMessage !== "" && (
        <ModalMessage
          message={infoModalMessage}
          onApprove={() => setInfoModalMessage("")}
        />
      )}
    </>
  );
};

export default StakeNumberMultiplier;
